<template>
  <v-card class="elevation-20">
    <v-card-title class="py-0">
      <v-list width="100%">
        <v-list-item>
          <v-list-item-icon>
            <v-progress-circular
              :indeterminate="indeterminate"
              :rotate="rotate"
              :size="size"
              :value="report.total"
              :width="width"
              color="light-blue"
            >{{ report.total }}</v-progress-circular>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="title">{{ report.Profession }}</v-list-item-title>
            <v-list-item-subtitle>{{ report.total }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-icon align="center">
            <img class="mt-4" height="45" :src="profileUrl(report.Profession)" color="success"/>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-card-title>
  </v-card>
</template>

<script>
export default {
  props: {
    report: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    indeterminate: false,
    rotate: 0,
    size: 60,
    value: 24,
    width: 5,
    
  }),
  methods:{
     profileUrl(prof) {
      if (prof == "Software Engineer") {
        return require("@/assets/images/SE/m.jpg");
      } else if (prof == "Senior Developer" || prof == "Developer") {
        return require("@/assets/images/DV/m.png");
      } else if(prof == "Student") return require("@/assets/images/ST/m.png");
    }
  }
};
</script>